import LeftHeader from './LeftHeaderContainer';

export default LeftHeader;